import classNames from 'classnames';
import { FC } from 'react';
import { Link as RouterLink, LinkProps } from 'react-router-dom';
import styles from '../Button/Button.module.css';

const Link: FC<LinkProps> = ({ ...props }) => (
  <RouterLink
    className={classNames(styles.textbutton, {
      [props.className!]: props.className !== undefined,
    })}
    {...props}
  />
);

export default Link;
